import { PlayCircleProps } from './types';

export const PlayCircle = ({
  width = 80,
  height = 80,
  className,
}: PlayCircleProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 80 80"
    >
      <g fill="none" fillRule="evenodd">
        <circle cx="40" cy="40" r="40" fill="currentColor" />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M49.791 39.608l-14.032-9.524a.495.495 0 00-.5-.03.475.475 0 00-.259.422v19.048a.476.476 0
          00.484.476.5.5 0 00.275-.084l14.032-9.524a.473.473 0 000-.784z"
        />
      </g>
    </svg>
  );
};
